webpackJsonp([61],{

/***/ 2380:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyTest_vue__ = __webpack_require__(2978);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404b7273_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyTest_vue__ = __webpack_require__(3155);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3134)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-404b7273"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyTest_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_404b7273_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyTest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/surveys/SurveyTest.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-404b7273", Component.options)
  } else {
    hotAPI.reload("data-v-404b7273", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2475:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseRadioGroup_vue__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_i18n_mixin__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_2__mixins_i18n_mixin__["a" /* default */])('public/views/survey')],
    components: {
        'radio-button': __WEBPACK_IMPORTED_MODULE_0__components_base_forms_BaseRadioGroup_vue__["default"],
        BCard: __WEBPACK_IMPORTED_MODULE_1_bootstrap_vue__["e" /* BCard */]
    },
    data: function data() {
        return {
            localValue: null
        };
    },

    props: {
        progress: {
            type: Number,
            required: true
        },
        questionnaireLength: {
            type: Number,
            required: true
        },
        question: {
            type: Object
        },
        value: {
            type: Number,
            default: null
        },
        stacked: {
            type: Boolean,
            default: false
        },
        labelsEnabled: {
            type: Boolean,
            default: false
        },
        fullWidthCard: {
            type: Boolean,
            default: false
        },
        customConditionToShowButton: {
            type: Boolean,
            default: false
        },
        customButtonText: {
            type: String
        }
    },
    created: function created() {
        var _this = this;

        this.localValue = this.value;
        this.$watch('localValue', function (value) {
            _this.$emit('input', value);
        });
        this.$watch('value', function (newValue) {
            _this.localValue = newValue;
        });
    },

    methods: {
        action: function action() {
            this.$emit('answerQuestion');
            if (this.lastQuestion) {
                this.$emit('submitQuestionnaire');
            }
        }
    },
    computed: {
        leastImportantAnswer: function leastImportantAnswer() {
            return this.question.answer[0].text;
        },
        mostImportantAnswer: function mostImportantAnswer() {
            return this.question.answer[this.question.answer.length - 1].text;
        },
        questionText: function questionText() {
            return this.customButtonText || this.question.resultText || this.$t(this.lastQuestion ? 'surveys.finish' : 'surveys.following');
        },
        lastQuestion: function lastQuestion() {
            return this.progress === this.questionnaireLength - 1;
        },
        showButton: function showButton() {
            return this.customConditionToShowButton || this.localValue != null;
        }
    }
});

/***/ }),

/***/ 2512:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionCard_vue__ = __webpack_require__(2475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_124970e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionCard_vue__ = __webpack_require__(2515);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2513)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QuestionCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_124970e4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/utils/QuestionCard.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-124970e4", Component.options)
  } else {
    hotAPI.reload("data-v-124970e4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 2513:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2514);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2ab9fb6a", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-124970e4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./QuestionCard.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-124970e4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./QuestionCard.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2514:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active,.slide-down-leave-active{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter,.slide-down-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active,.slide-fade-left-leave-active{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter,.slide-fade-left-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter,.fade-leave-to{opacity:0\n}\ndiv.custom-radio.b-custom-control-lg:has(span:empty){margin-right:3%;margin-left:3%\n}\n@media only screen and (max-width: 575px){\ndiv.custom-radio.b-custom-control-lg:has(span:empty){margin:0.5%\n}\n}\n.slidesSize{width:100%;position:relative;z-index:1\n}\n.subtitle-card{color:#3238C4;font-weight:bold;font-size:1.25rem;white-space:normal\n}\n@media only screen and (max-width: 575px){\n.subtitle-card{font-size:1rem;display:inline-block\n}\n}\n", ""]);

// exports


/***/ }),

/***/ 2515:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.question
      ? _c(
          "div",
          { key: _vm.question.id, staticClass: "slidesSize" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass: "mx-auto centered",
                    attrs: {
                      cols: "12",
                      md: _vm.fullWidthCard ? 12 : 10,
                      lg: _vm.fullWidthCard ? 12 : 8
                    }
                  },
                  [
                    _c(
                      "b-card",
                      { staticClass: "neu-card neu-card-sv" },
                      [
                        _vm._t("title"),
                        _vm._v(" "),
                        _c("h2", [_vm._v(_vm._s(_vm.question.question))]),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm._t("question"),
                            _vm._v(" "),
                            !_vm.$slots.question
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "b-row",
                                      [
                                        _c(
                                          "b-col",
                                          {
                                            class: [
                                              _vm.stacked
                                                ? "d-flex justify-content-center"
                                                : ""
                                            ]
                                          },
                                          [
                                            _c("radio-button", {
                                              class: [
                                                _vm.stacked
                                                  ? "text-left mx-auto centered"
                                                  : "mx-auto centered"
                                              ],
                                              staticStyle: {
                                                "box-sizing": "border-box"
                                              },
                                              attrs: {
                                                labelsEnabled:
                                                  _vm.labelsEnabled,
                                                options: _vm.question.answer,
                                                stacked: _vm.stacked
                                              },
                                              model: {
                                                value: _vm.localValue,
                                                callback: function($$v) {
                                                  _vm.localValue = $$v
                                                },
                                                expression: "localValue"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.stacked && !_vm.labelsEnabled
                                      ? _c(
                                          "b-row",
                                          [
                                            _c(
                                              "b-col",
                                              {
                                                staticClass: "subtitle-card",
                                                attrs: {
                                                  cols: "6",
                                                  sm: "6",
                                                  lg: "3"
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.leastImportantAnswer
                                                    )
                                                  )
                                                ])
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-col",
                                              {
                                                staticClass:
                                                  "float-right subtitle-card ml-auto",
                                                attrs: {
                                                  cols: "6",
                                                  sm: "6",
                                                  lg: "3"
                                                }
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.mostImportantAnswer
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._t("additionalComment"),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _vm.showButton
                                  ? _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "px-0 pt-1 px-md-5 pt-md-3 float-right m-auto",
                                        attrs: { xs: "12", lg: "8" }
                                      },
                                      [
                                        _c(
                                          "transition",
                                          {
                                            attrs: { name: "fade", appear: "" }
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary w-100",
                                                attrs: { type: "button" },
                                                on: {
                                                  "~click": function($event) {
                                                    return _vm.action.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-center"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.questionText)
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "float-right m-auto"
                                                  },
                                                  [
                                                    _c("base-icon", {
                                                      attrs: {
                                                        src:
                                                          "/static-appopensalud/img/icons/morillas-svg-icons/primary/arrow.svg",
                                                        color: "white"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          2
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-124970e4", esExports)
  }
}

/***/ }),

/***/ 2793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
var client=function client(){return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$api;};/* harmony default export */ __webpack_exports__["a"] = ({getAllItemsBySurvey:function getAllItemsBySurvey(surveyId){var disabledPagination=true;return client().get("/surveys/items/"+surveyId,{params:{disabledPagination:disabledPagination}});},postSurveyItemAnswer:function postSurveyItemAnswer(answerData){return client().post("/surveys/item-answers",answerData);},postSurveyAnswer:function postSurveyAnswer(surveyId){return client().post("/surveys/answers",null,{params:{idSurvey:surveyId}});},checkSurveyCompleted:function checkSurveyCompleted(surveyId){return client().get("/surveys/"+surveyId);},getLastAnsweredItem:function getLastAnsweredItem(surveyId){return client().get('/surveys/item-answers',{params:{surveyId:surveyId}});},checkBusinessCodesByUser:function checkBusinessCodesByUser(){return client().get('/surveys/users/business');},checkGroupCodesByUser:function checkGroupCodesByUser(){return client().get('/surveys/users/groups');},getSurveyAvailable:function getSurveyAvailable(){return client().get('/survey-available');}});

/***/ }),

/***/ 2978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__repositories_SurveyRepository__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SurveyTemplate_vue__ = __webpack_require__(3136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__repositories_AccountRepository__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_i18n_mixin__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_utils_LoadingAnim_vue__ = __webpack_require__(69);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var I18N_FILE = 'public/views/survey';

var EVENTS = {
    SURVEY_COMPLETED: 'surveyCompleted',
    SURVEY_STEP_CHANGED: 'surveyStepChanged',
    SURVEY_STARTED: 'surveyStarted'
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_7__mixins_i18n_mixin__["a" /* default */])(I18N_FILE)],
    components: {
        SurveyTemplate: __WEBPACK_IMPORTED_MODULE_5__SurveyTemplate_vue__["a" /* default */],
        LoadingAnim: __WEBPACK_IMPORTED_MODULE_8__components_utils_LoadingAnim_vue__["default"]
    },
    props: {
        surveyIdProp: {
            type: String,
            default: null
        }
    },
    data: function data() {
        return {
            surveyId: null,
            surveyTitle: '',
            surveyItems: [],
            surveyData: null,
            userBusinessCodes: [],
            userGroupCodes: [],
            loading: true,
            fromDialog: false
        };
    },

    computed: {
        userIsPatient: function userIsPatient() {
            return this.$store.getters['session/userIsPatient'];
        },
        userIsCenter: function userIsCenter() {
            return this.$store.getters['session/userIsCenter'];
        },
        userIsProfessional: function userIsProfessional() {
            return this.$store.getters['session/userIsProfessional'];
        },
        canAccessRole: function canAccessRole() {
            if (!this.surveyData) return false;
            return this.surveyData.data.patient && this.userIsPatient || this.surveyData.data.professional && this.userIsProfessional || this.surveyData.data.center && this.userIsCenter;
        },
        hasMatchingBusinessCode: function hasMatchingBusinessCode() {
            var _this = this;

            if (!this.surveyData) return false;
            if (this.surveyData.data.forBusiness) {
                return this.userBusinessCodes.length > 0;
            } else {
                return this.surveyData.data.businessCodeList.length === 0 || this.surveyData.data.businessCodeList.some(function (code) {
                    return _this.userBusinessCodes.includes(code);
                });
            }
        },
        hasMatchingGroupCode: function hasMatchingGroupCode() {
            var _this2 = this;

            if (!this.surveyData) return false;
            return this.surveyData.data.codeGroupList.length === 0 || this.surveyData.data.codeGroupList.some(function (code) {
                return _this2.userGroupCodes.includes(code);
            });
        },
        isSurveyAccessible: function isSurveyAccessible() {
            return this.canAccessRole && this.hasMatchingBusinessCode && this.hasMatchingGroupCode;
        }
    },
    watch: {
        surveyIdProp: function surveyIdProp(newSurveyId) {
            if (newSurveyId) {
                this.surveyId = newSurveyId;
                this.fetchSurveyData();
            }
        }
    },
    mounted: function mounted() {
        var _this3 = this;

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _this3.surveyId = _this3.surveyIdProp || _this3.$route.params.surveyId;
                            _this3.fromDialog = _this3.surveyIdProp != null;

                            if (_this3.surveyId) {
                                _context.next = 5;
                                break;
                            }

                            _this3.$router.push('/patient');
                            return _context.abrupt('return');

                        case 5:
                            _context.next = 7;
                            return _this3.fetchSurveyData();

                        case 7:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this3);
        }))();
    },

    methods: {
        handleSurveyCompleted: function handleSurveyCompleted() {
            this.$emit(EVENTS.SURVEY_COMPLETED);
        },
        handleSurveyStepChanged: function handleSurveyStepChanged(stepIndex) {
            this.$emit(EVENTS.SURVEY_STEP_CHANGED, stepIndex);
        },
        handleSurveyStarted: function handleSurveyStarted() {
            this.$emit(EVENTS.SURVEY_STARTED);
        },
        handleSurveyLoaded: function handleSurveyLoaded() {
            this.loading = false;
        },
        fetchSurveyData: function fetchSurveyData() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
                var loginInfoResponse, _ref, _ref2, surveyResponse, businessCodesResponse, groupCodesResponse;

                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_6__repositories_AccountRepository__["a" /* default */].getSession();

                            case 3:
                                loginInfoResponse = _context2.sent;

                                _this4.$store.dispatch('session/set', loginInfoResponse.data);

                                // Cargar datos en paralelo
                                _context2.next = 7;
                                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([__WEBPACK_IMPORTED_MODULE_4__repositories_SurveyRepository__["a" /* default */].getAllItemsBySurvey(_this4.surveyId), __WEBPACK_IMPORTED_MODULE_4__repositories_SurveyRepository__["a" /* default */].checkBusinessCodesByUser(), __WEBPACK_IMPORTED_MODULE_4__repositories_SurveyRepository__["a" /* default */].checkGroupCodesByUser()]);

                            case 7:
                                _ref = _context2.sent;
                                _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 3);
                                surveyResponse = _ref2[0];
                                businessCodesResponse = _ref2[1];
                                groupCodesResponse = _ref2[2];


                                _this4.surveyData = surveyResponse;
                                _this4.userBusinessCodes = businessCodesResponse.data || [];
                                _this4.userGroupCodes = groupCodesResponse.data || [];
                                _this4.$store.commit('survey/setSurvey', _this4.surveyData.data.surveyName);

                                if (_this4.isSurveyAccessible) {
                                    _this4.surveyItems = _this4.surveyData.data.items;
                                    _this4.surveyTitle = _this4.surveyData.data.surveyName;
                                }
                                _context2.next = 22;
                                break;

                            case 19:
                                _context2.prev = 19;
                                _context2.t0 = _context2['catch'](0);

                                _this4.$store.dispatch('showDangerAlert', _this4.$i18n.t('surveys.error.error-loading'));

                            case 22:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, _this4, [[0, 19]]);
            }))();
        }
    }
});

/***/ }),

/***/ 2979:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(3139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__repositories_SurveyRepository__ = __webpack_require__(2793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_i18n_mixin__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_utils_QuestionCard_vue__ = __webpack_require__(2512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_account_mixin__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_utils_LoadingAnim__ = __webpack_require__(69);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var I18N_FILE = 'public/views/survey';

var EVENTS = {
    SURVEY_COMPLETED: 'surveyCompleted',
    SURVEY_STEP_CHANGED: 'surveyStepChanged',
    SURVEY_STARTED: 'surveyStarted',
    SURVEY_LOADED: 'surveyLoaded'
};

/* harmony default export */ __webpack_exports__["a"] = ({
    mixins: [Object(__WEBPACK_IMPORTED_MODULE_6__mixins_i18n_mixin__["a" /* default */])(I18N_FILE), __WEBPACK_IMPORTED_MODULE_8__mixins_account_mixin__["a" /* default */]],
    components: {
        BCard: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["e" /* BCard */],
        BProgress: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["_43" /* BProgress */],
        BProgressBar: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["_44" /* BProgressBar */],
        BFormGroup: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["r" /* BFormGroup */],
        BFormTextarea: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["A" /* BFormTextarea */],
        BButton: __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["d" /* BButton */],
        QuestionCard: __WEBPACK_IMPORTED_MODULE_7__components_utils_QuestionCard_vue__["a" /* default */],
        LoadingAnim: __WEBPACK_IMPORTED_MODULE_9__components_utils_LoadingAnim__["default"]
    },
    props: {
        surveyTitle: { type: Object, required: true },
        surveyId: { type: String, required: true },
        items: { type: Array, required: true },
        fromDialog: { type: Boolean, required: false, default: false }
    },
    data: function data() {
        return {
            currentIndex: 0,
            surveyCompleted: false,
            loading: true,
            responses: {},
            answeredItems: new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(),
            ratingError: false,
            started: false
        };
    },

    computed: {
        userIsPatient: function userIsPatient() {
            return this.$store.getters['session/userIsPatient'];
        },
        userIsCenter: function userIsCenter() {
            return this.$store.getters['session/userIsCenter'];
        },
        userIsProfessional: function userIsProfessional() {
            return this.$store.getters['session/userIsProfessional'];
        },
        showOpenSaludButton: function showOpenSaludButton() {
            return this.$route.path.includes('/survey/');
        },
        progressPercentage: function progressPercentage() {
            if (this.items.length === 0) return 0;
            return Math.round(this.answeredItems.size / this.items.length * 100);
        },
        currentItem: function currentItem() {
            var _this = this;

            return this.items.find(function (item) {
                return !_this.answeredItems.has(item.id);
            });
        },

        question: {
            get: function get() {
                if (!this.currentItem) return null;
                return {
                    question: this.$i18nHelpers.normalize(this.currentItem.description),
                    answer: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(10))).map(function (_, i) {
                        return { value: i + 1 };
                    }),
                    result: this.responses[this.currentItem.id].rating
                };
            }
        },
        questionResult: {
            get: function get() {
                return this.question ? this.question.result : null;
            },
            set: function set(newValue) {
                if (this.currentItem) {
                    this.$set(this.responses[this.currentItem.id], 'rating', newValue);
                }
            }
        }
    },
    watch: {
        items: function items(newItems) {
            if (newItems.length > 0) {
                this.initializeResponses();
                this.setLastAnsweredItems();
            }
        },
        currentIndex: function currentIndex() {
            this.$emit(EVENTS.SURVEY_STEP_CHANGED, this.currentIndex);
            this.$forceUpdate();
        },

        progressPercentage: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(val) {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                this.$emit(EVENTS.SURVEY_STARTED);

                                if (!(val === 100)) {
                                    _context.next = 4;
                                    break;
                                }

                                _context.next = 4;
                                return this.submitSurvey();

                            case 4:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function progressPercentage(_x) {
                return _ref.apply(this, arguments);
            }

            return progressPercentage;
        }()
    },
    created: function created() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return _this2.checkSurveyStatus();

                        case 2:
                            if (_this2.surveyCompleted) {
                                _context2.next = 6;
                                break;
                            }

                            _context2.next = 5;
                            return _this2.setLastAnsweredItems();

                        case 5:
                            _this2.initializeResponses();

                        case 6:
                            _this2.loading = false;
                            _this2.$emit(EVENTS.SURVEY_LOADED);

                        case 8:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, _this2);
        }))();
    },

    methods: {
        goToOpenSalud: function goToOpenSalud() {
            return this.goToSessionRoot();
        },
        checkSurveyStatus: function checkSurveyStatus() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.prev = 0;
                                _context3.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_5__repositories_SurveyRepository__["a" /* default */].checkSurveyCompleted(_this3.surveyId);

                            case 3:
                                response = _context3.sent;

                                _this3.surveyCompleted = response.data;
                                _context3.next = 10;
                                break;

                            case 7:
                                _context3.prev = 7;
                                _context3.t0 = _context3['catch'](0);

                                _this3.$store.dispatch('showDangerAlert', _this3.$i18n.t('surveys.error.error-loading'));

                            case 10:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, _this3, [[0, 7]]);
            }))();
        },
        setLastAnsweredItems: function setLastAnsweredItems() {
            var _this4 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4() {
                var response;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.prev = 0;
                                _context4.next = 3;
                                return __WEBPACK_IMPORTED_MODULE_5__repositories_SurveyRepository__["a" /* default */].getLastAnsweredItem(_this4.surveyId);

                            case 3:
                                response = _context4.sent;

                                _this4.answeredItems = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(response.data || []);
                                _this4.currentIndex = _this4.answeredItems.size;
                                _context4.next = 11;
                                break;

                            case 8:
                                _context4.prev = 8;
                                _context4.t0 = _context4['catch'](0);

                                _this4.$store.dispatch('showDangerAlert', _this4.$i18n.t('surveys.error.error-loading'));

                            case 11:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, _this4, [[0, 8]]);
            }))();
        },
        initializeResponses: function initializeResponses() {
            var _this5 = this;

            this.items.forEach(function (item) {
                if (!_this5.responses[item.id]) {
                    _this5.setItemResponses(item.id);
                }
            });
        },
        saveCurrentAnswer: function saveCurrentAnswer() {
            var _this6 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5() {
                var currentItem;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                currentItem = _this6.currentItem;

                                if (!(!currentItem || !currentItem.id)) {
                                    _context5.next = 3;
                                    break;
                                }

                                return _context5.abrupt('return');

                            case 3:

                                if (!_this6.responses[currentItem.id]) {
                                    _this6.setItemResponses(currentItem.id);
                                }

                                if (!(_this6.responses[currentItem.id].rating === null)) {
                                    _context5.next = 7;
                                    break;
                                }

                                _this6.ratingError = true;
                                return _context5.abrupt('return');

                            case 7:
                                _this6.ratingError = false;

                                _context5.prev = 8;
                                _context5.next = 11;
                                return __WEBPACK_IMPORTED_MODULE_5__repositories_SurveyRepository__["a" /* default */].postSurveyItemAnswer({
                                    Rating: _this6.responses[currentItem.id].rating,
                                    FreeText: _this6.responses[currentItem.id].freeText,
                                    ItemId: currentItem.id,
                                    SurveyId: _this6.surveyId
                                });

                            case 11:

                                if (!_this6.answeredItems.has(currentItem.id)) {
                                    _this6.answeredItems.add(currentItem.id);
                                }

                                _this6.setLastAnsweredItems();
                                _context5.next = 18;
                                break;

                            case 15:
                                _context5.prev = 15;
                                _context5.t0 = _context5['catch'](8);

                                _this6.$store.dispatch('showDangerAlert', _this6.$i18n.t('surveys.error.error-loading'));

                            case 18:
                            case 'end':
                                return _context5.stop();
                        }
                    }
                }, _callee5, _this6, [[8, 15]]);
            }))();
        },
        submitSurvey: function submitSurvey() {
            var _this7 = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6() {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                _context6.next = 2;
                                return _this7.saveCurrentAnswer();

                            case 2:
                                if (!(_this7.answeredItems.size < _this7.items.length)) {
                                    _context6.next = 5;
                                    break;
                                }

                                _this7.$store.dispatch('showDangerAlert', _this7.$i18n.t('surveys.info.error-finish'));
                                return _context6.abrupt('return');

                            case 5:
                                _context6.prev = 5;
                                _context6.next = 8;
                                return __WEBPACK_IMPORTED_MODULE_5__repositories_SurveyRepository__["a" /* default */].postSurveyAnswer(_this7.surveyId);

                            case 8:
                                _this7.surveyCompleted = true;
                                _this7.$emit(EVENTS.SURVEY_COMPLETED);
                                _context6.next = 15;
                                break;

                            case 12:
                                _context6.prev = 12;
                                _context6.t0 = _context6['catch'](5);

                                _this7.$store.dispatch('showDangerAlert', _this7.$i18n.t('surveys.error.error-send'));

                            case 15:
                            case 'end':
                                return _context6.stop();
                        }
                    }
                }, _callee6, _this7, [[5, 12]]);
            }))();
        },
        setItemResponses: function setItemResponses(itemId) {
            this.$set(this.responses, itemId, { rating: null, freeText: '' });
        },
        handleSurveyStart: function handleSurveyStart() {
            this.started = true;
            this.currentIndex = 0;
            this.$emit(EVENTS.SURVEY_STARTED);
        }
    }
});

/***/ }),

/***/ 2980:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(111);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),

/***/ 3134:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3135);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("2f83368b", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-404b7273\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SurveyTest.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-404b7273\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SurveyTest.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3135:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.loading-container[data-v-404b7273] {\n    text-align: center;\n    margin-top: 50px;\n    font-size: 1.2rem;\n    font-weight: bold;\n}\n.survey-unavailable[data-v-404b7273] {\n    text-align: center;\n    margin-top: 50px;\n}\n", ""]);

// exports


/***/ }),

/***/ 3136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyTemplate_vue__ = __webpack_require__(2979);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d479db_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyTemplate_vue__ = __webpack_require__(3154);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(3137)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34d479db"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SurveyTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d479db_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SurveyTemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/surveys/SurveyTemplate.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34d479db", Component.options)
  } else {
    hotAPI.reload("data-v-34d479db", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 3137:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3138);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("56394e37", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34d479db\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SurveyTemplate.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-34d479db\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./SurveyTemplate.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 3138:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-34d479db]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-34d479db],.slide-down-leave-active[data-v-34d479db]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-34d479db],.slide-down-leave-to[data-v-34d479db]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-34d479db],.slide-fade-left-leave-active[data-v-34d479db]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-34d479db],.slide-fade-left-leave-to[data-v-34d479db]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-34d479db]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-34d479db],.fade-leave-to[data-v-34d479db]{opacity:0\n}\n.survey-container[data-v-34d479db]{display:contents;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column\n}\n[data-v-34d479db] .neu-card-sv{-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:1px solid #eee;border-radius:23px;display:block;background-color:#eee;-webkit-transition:all .5s ease;transition:all .5s ease;text-align:center;margin-top:auto;margin-bottom:auto;padding:2rem\n}\n.progress-container[data-v-34d479db]{width:100%;text-align:center;margin-bottom:2rem\n}\n.progress-bar[data-v-34d479db]{height:5px;background-color:#ccc !important\n}\n.progress-bar-inner[data-v-34d479db]{-webkit-transition:width 0.5s ease-in-out;transition:width 0.5s ease-in-out;background-color:#2d2df5 !important\n}\n.survey-step[data-v-34d479db]{width:100%\n}\n.survey-completed[data-v-34d479db]{text-align:center;padding:20px\n}\n.loading-container[data-v-34d479db]{text-align:center;padding:20px\n}\n.error-text[data-v-34d479db]{color:#FF7061;font-size:0.9rem;font-weight:bold;margin-top:5px\n}\n", ""]);

// exports


/***/ }),

/***/ 3139:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(3140), __esModule: true };

/***/ }),

/***/ 3140:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(547);
__webpack_require__(188);
__webpack_require__(225);
__webpack_require__(3141);
__webpack_require__(3147);
__webpack_require__(3150);
__webpack_require__(3152);
module.exports = __webpack_require__(39).Set;


/***/ }),

/***/ 3141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(3142);
var validate = __webpack_require__(2980);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(3143)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),

/***/ 3142:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(100).f;
var create = __webpack_require__(529);
var redefineAll = __webpack_require__(1300);
var ctx = __webpack_require__(185);
var anInstance = __webpack_require__(1299);
var forOf = __webpack_require__(1286);
var $iterDefine = __webpack_require__(548);
var step = __webpack_require__(1309);
var setSpecies = __webpack_require__(1310);
var DESCRIPTORS = __webpack_require__(87);
var fastKey = __webpack_require__(1303).fastKey;
var validate = __webpack_require__(2980);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),

/***/ 3143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(56);
var $export = __webpack_require__(70);
var meta = __webpack_require__(1303);
var fails = __webpack_require__(162);
var hide = __webpack_require__(128);
var redefineAll = __webpack_require__(1300);
var forOf = __webpack_require__(1286);
var anInstance = __webpack_require__(1299);
var isObject = __webpack_require__(111);
var setToStringTag = __webpack_require__(224);
var dP = __webpack_require__(100).f;
var each = __webpack_require__(3144)(0);
var DESCRIPTORS = __webpack_require__(87);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  if (!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    C = wrapper(function (target, iterable) {
      anInstance(target, C, NAME, '_c');
      target._c = new Base();
      if (iterable != undefined) forOf(iterable, IS_MAP, target[ADDER], target);
    });
    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','), function (KEY) {
      var IS_ADDER = KEY == 'add' || KEY == 'set';
      if (KEY in proto && !(IS_WEAK && KEY == 'clear')) hide(C.prototype, KEY, function (a, b) {
        anInstance(this, C, KEY);
        if (!IS_ADDER && IS_WEAK && !isObject(a)) return KEY == 'get' ? undefined : false;
        var result = this._c[KEY](a === 0 ? 0 : a, b);
        return IS_ADDER ? this : result;
      });
    });
    IS_WEAK || dP(C.prototype, 'size', {
      get: function () {
        return this._c.size;
      }
    });
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F, O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),

/***/ 3144:
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(185);
var IObject = __webpack_require__(549);
var toObject = __webpack_require__(183);
var toLength = __webpack_require__(299);
var asc = __webpack_require__(3145);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ 3145:
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(3146);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ 3146:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(111);
var isArray = __webpack_require__(1311);
var SPECIES = __webpack_require__(57)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ 3147:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(70);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(3148)('Set') });


/***/ }),

/***/ 3148:
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(300);
var from = __webpack_require__(3149);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),

/***/ 3149:
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(1286);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),

/***/ 3150:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(3151)('Set');


/***/ }),

/***/ 3151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(70);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),

/***/ 3152:
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(3153)('Set');


/***/ }),

/***/ 3153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(70);
var aFunction = __webpack_require__(223);
var ctx = __webpack_require__(185);
var forOf = __webpack_require__(1286);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),

/***/ 3154:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "survey-container" },
    [
      _vm.surveyCompleted
        ? _c(
            "div",
            { staticClass: "survey-completed mt-3" },
            [
              _c(
                "b-col",
                { staticClass: "mx-auto centered", attrs: { cols: "12" } },
                [
                  _c(
                    "b-card",
                    [
                      _c("base-icon", {
                        attrs: {
                          width: "100px",
                          height: "100px",
                          src: "/static-appopensalud/img/icons/full.png",
                          color: "blue"
                        }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("h5", { staticClass: "text-center mt-5" }, [
                        _vm._v(_vm._s(this.$i18n.t("surveys.completed2")))
                      ]),
                      _vm._v(" "),
                      _vm.fromDialog
                        ? _c("p", { staticClass: "text-center mt-5" }, [
                            _vm._v(_vm._s(this.$i18n.t("surveys.close-dialog")))
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showOpenSaludButton
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-5",
                              attrs: { variant: "primary", block: "" },
                              on: { click: _vm.goToOpenSalud }
                            },
                            [
                              _vm._v(
                                _vm._s(this.$i18n.t("surveys.opensalud-go")) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { staticClass: "mt-3", attrs: { name: "fade", mode: "out-in" } },
        [
          !_vm.loading && !_vm.surveyCompleted && _vm.items.length > 0
            ? _c("div", { staticClass: "survey-step" }, [
                !_vm.started
                  ? _c("h2", { staticClass: "text-center mb-5" }, [
                      _vm._v(
                        _vm._s(_vm.$i18nHelpers.normalize(_vm.surveyTitle))
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.started
                  ? _c(
                      "div",
                      { staticClass: "text-center" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary" },
                            on: { click: _vm.handleSurveyStart }
                          },
                          [_vm._v(_vm._s(this.$i18n.t("surveys.start")))]
                        )
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "div",
                          { staticClass: "progress-container" },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.progressPercentage) +
                                  _vm._s(
                                    this.$i18n.t("surveys.percentage-completed")
                                  )
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "b-progress",
                              { staticClass: "progress-bar" },
                              [
                                _c("b-progress-bar", {
                                  staticClass: "progress-bar-inner",
                                  attrs: {
                                    value: _vm.progressPercentage,
                                    max: 100
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("question-card", {
                          attrs: {
                            labelsEnabled: "",
                            question: _vm.question,
                            progress: _vm.answeredItems.size,
                            questionnaireLength: _vm.items.length,
                            fullWidthCard: ""
                          },
                          on: {
                            answerQuestion: _vm.saveCurrentAnswer,
                            submitQuestionnaire: function() {}
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "additionalComment",
                                fn: function() {
                                  return [
                                    _c(
                                      "b-form-group",
                                      { staticClass: "mt-3" },
                                      [
                                        _vm.responses[_vm.currentItem.id]
                                          ? _c("b-form-textarea", {
                                              attrs: {
                                                rows: "2",
                                                "max-rows": "4",
                                                placeholder: _vm.$i18n.t(
                                                  "surveys.comment-review"
                                                ),
                                                "no-resize": ""
                                              },
                                              model: {
                                                value:
                                                  _vm.responses[
                                                    _vm.currentItem.id
                                                  ].freeText,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.responses[
                                                      _vm.currentItem.id
                                                    ],
                                                    "freeText",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "responses[currentItem.id].freeText"
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            969386706
                          ),
                          model: {
                            value: _vm.questionResult,
                            callback: function($$v) {
                              _vm.questionResult = $$v
                            },
                            expression: "questionResult"
                          }
                        })
                      ],
                      1
                    )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34d479db", esExports)
  }
}

/***/ }),

/***/ 3155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? [
            _c("div", { staticClass: "loading-container" }, [
              _c("p", [_vm._v(_vm._s(_vm.$t("surveys.loading")))])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.isSurveyAccessible
        ? [
            _c("SurveyTemplate", {
              attrs: {
                surveyTitle: _vm.surveyTitle,
                surveyId: _vm.surveyId,
                items: _vm.surveyItems,
                fromDialog: _vm.fromDialog
              },
              on: {
                surveyCompleted: _vm.handleSurveyCompleted,
                surveyStepChanged: _vm.handleSurveyStepChanged,
                surveyStarted: _vm.handleSurveyStarted,
                surveyLoaded: _vm.handleSurveyLoaded
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.isSurveyAccessible && !_vm.loading
        ? [
            _c("div", { staticClass: "survey-unavailable" }, [
              _c("h3", [_vm._v(_vm._s(_vm.$i18n.t("surveys.not-avaliable")))]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$i18n.t("surveys.not-allowed")))])
            ])
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-404b7273", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/61.503203998ef44d58af3e.js